// TODO: From App New
<template>
  <div>
    <!-- Loading State -->
    <div
      v-if="loading"
      class="text-center py-5"
    >
      <b-spinner
        variant="primary"
        class="mb-2"
      />
      <h5 class="text-muted">
        Memuat data produk...
      </h5>
    </div>

    <!-- Empty State -->
    <div
      v-else-if="!products.length && !loading"
      class="text-center py-5"
    >
      <feather-icon
        icon="PackageIcon"
        size="48"
        class="text-muted mb-2"
      />
      <h5 class="text-muted">
        Belum ada produk yang ditambahkan
      </h5>
      <p class="text-muted">
        Pilih produk dari dropdown di atas untuk mulai mengatur harga promo.
      </p>
    </div>

    <!-- Product Cards -->
    <transition-group
      v-else
      name="fade-bottom"
      tag="ul"
      class="list-group list-group-flush"
    >
      <li
        v-for="product in products"
        :key="`product-${product.id}`"
        style="list-style: none"
      >
        <SaleProductCard
          :product="product"
          :is-admin="isAdmin"
          :is-sale-ongoing="isSaleOngoing"
          @flag-product="$emit('flag-product', $event)"
          @highlight-product="$emit('highlight-product', $event)"
          @remove-product="$emit('remove-product', $event)"
          @bulk-price-change="$emit('bulk-price-change', $event, arguments[1])"
          @sale-price-change="$emit('sale-price-change', $event, arguments[1], arguments[2])"
          @toggle-variant-sale="$emit('toggle-variant-sale', arguments[0], arguments[1])"
          @submit-sale-price-change="$emit('submit-sale-price-change', $event)"
          @bulk-discount-change="$emit('bulk-discount-change', $event, arguments[1])"
          @discount-change="$emit('discount-change', $event, arguments[1], arguments[2])"
          @submit-discount-change="$emit('submit-discount-change', $event)"
          @submit-bulk-discount-change="$emit('submit-bulk-discount-change', $event)"
        />
      </li>
    </transition-group>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'
import SaleProductCard from './SaleProductCard.vue'

export default {
  name: 'SaleProductList',
  components: {
    BSpinner,
    SaleProductCard,
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    isSaleOngoing: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'flag-product',
    'highlight-product',
    'remove-product',
    'bulk-price-change',
    'sale-price-change',
    'toggle-variant-sale',
    'before-sale-price-change',
    'submit-sale-price-change',
  ],
}
</script>
